"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.AddPersonalNutritionItems = void 0;
const Name = exports.Name = 'add-personal-nutrition-items';
const AddPersonalNutritionItems = exports.AddPersonalNutritionItems = Name;
//# sourceMappingURL=index.js.map